import { render, staticRenderFns } from "./BuyBar.vue?vue&type=template&id=0a95dedc&"
import script from "./BuyBar.vue?vue&type=script&lang=js&"
export * from "./BuyBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports